export const SET_LOADING = 'SET_LOADING'
export const SET_COMMISSION = 'SET_COMMISSION'
export const SET_LAST_SOLD_ITEMS = 'SET_LAST_SOLD_ITEMS'
export const SET_ORDER_SUMMARY = 'SET_ORDER_SUMMARY'
export const SET_GRAPH_SUMMARY = 'SET_GRAPH_SUMMARY'
export const SET_BEST_SELLER_ITEMS = 'SET_BEST_SELLER_ITEMS'
export const SET_EWALLET = 'SET_EWALLET'
